import type { TireSeason } from '@navio/nsdk';
import { filterUrlState } from 'noddi-ui-web';
import { ArrayParam, NumberParam, StringParam, useQueryParams } from 'use-query-params';
import { normalizeTireAxleFitments, type TireAxleFitment } from './tireAxleFitments';
import { TIRE_AXLE_URL_KEYS, tireAxleUrlParams } from './tireAxleFitmentsFilter';

/** Size and index filters the axle requirements replace: either would contradict them. */
const REPLACED_PARAMS = [
  'dimension',
  'excludedDimension',
  'dimensionWidthMmIn',
  'excludedDimensionWidthMmIn',
  'dimensionProfileIn',
  'excludedDimensionProfileIn',
  'dimensionRimInchIn',
  'excludedDimensionRimInchIn',
  'loadIndexGte',
  'excludedLoadIndex',
  'speedIndexGte',
  'excludedSpeedIndex',
  'excludedSeason'
] as const;

const SEASON_URL_KEY = filterUrlState.urlKey('season');

// Every key is only cleared here, so its decoder does not matter; the axle keys keep the filter's own.
const fitmentParams = {
  ...tireAxleUrlParams,
  ...Object.fromEntries(REPLACED_PARAMS.map((param) => [filterUrlState.urlKey(param), StringParam])),
  [SEASON_URL_KEY]: ArrayParam,
  page: NumberParam
};

/**
 * Applies a quote's axle requirements and season to the tire inventory filters (`useTireInventoryFilters`) in one
 * URL write: confirming defaults must not load inventory facets or apply half a selection.
 */
export const useTireFitmentFilterParams = () => {
  const [, setParams] = useQueryParams(fitmentParams, { updateType: 'replaceIn' });
  return {
    applyFitments: (fitments: TireAxleFitment[], season: TireSeason[]) =>
      setParams({
        ...Object.fromEntries(REPLACED_PARAMS.map((param) => [filterUrlState.urlKey(param), undefined])),
        [TIRE_AXLE_URL_KEYS.fitments]: normalizeTireAxleFitments(fitments),
        [TIRE_AXLE_URL_KEYS.axle]: undefined,
        page: undefined,
        [SEASON_URL_KEY]: season
      })
  };
};
